<template>
  <EventListener
    :events="[
      'rider_created',
      'failed_to_create_rider',
      'rider_creation_requested',
    ]"
    @rider_created="onRiderCreated"
    @failed_to_create_rider="onRiderCreationFailed"
    @rider_creation_requested="initRiderAdding"
  />
</template>

<script>
import { defineComponent } from 'vue'
import EventListener from '../utils/EventListener.vue'

export default defineComponent({
  name: 'AddNewRider',
  components: { EventListener },
  data() {
    return {}
  },
  mounted() {},

  methods: {
    async initRiderAdding() {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: this.$t('riders.newRiderFormTitle'),
          subTitle: this.$t('riders.newRiderFormDescription'),
          formFields: [
            // {
            //   type: 'text',
            //   label: this.$t('riders.firstNameInputLabel'),
            //   propertyName: 'firstName',
            //   placeHolder: this.$t('riders.firstNameInputPlaceHolder'),
            //   defaultValue: '',
            //   required: true,
            //   class: 'col-span-6',
            // },
            // {
            //   type: 'text',
            //   propertyName: 'lastName',
            //   label: this.$t('riders.lastNameInputLabel'),
            //   defaultValue: '',
            //   placeHolder: this.$t('riders.lastNameInputPlaceHolder'),
            //   required: true,
            //   class: 'col-span-6',
            // },
            {
              placeHolder: this.$t('riders.emailInputPlaceHolder'),
              type: 'email',
              propertyName: 'email',
              label: this.$t('riders.emailInputLabel'),
              defaultValue: '',
              required: true,
              class: 'col-span-12',
            },
          ],
          successText: this.$t('riders.addRiderFormSubmitButton'),
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      await new Promise((r)=>setTimeout(r, 500))
      this.$Events.dispatchEvent('start_loading')
      this.$Events.dispatchEvent('new_rider_ready_to_be_added', prompt.data)
    },
    onRiderCreated() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Livreur ajouté',
        body: 'Votre livreur a été ajouté avec succès',
      })
      this.$router.back()
    },
    onRiderCreationFailed() {
      this.$Events.dispatchEvent('finish_loading')
      this.$Events.dispatchEvent('toast_notification', {
        title: 'Livreur non ajouté',
        body: "Erreur d'ajout du livreur, veuillez réessayer",
      })
    },
  },
})
</script>

<style scoped></style>
